import { RootState } from "../store";

export const getStatisticsItems = (state: RootState) => {
  return state.statisticsReducer.items;
};

export const getStatisticsCount = (state: RootState) => {
  return state.statisticsReducer.count;
};

export const getStatisticsPage = (state: RootState) => {
  return state.statisticsReducer.page;
};

export const getStatisticsPageSize = (state: RootState) => {
  return state.statisticsReducer.pageSize;
};

export const getStatisticsPending = (state: RootState) => {
  return state.statisticsReducer.pending;
};

export const getStatisticsError = (state: RootState) => {
  return state.statisticsReducer.error;
};
